import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  TextField,
  Card,
  CardContent,
  CardActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { loginUser } from '../login/loginServices';
import { getNewUser } from '../Constants';
import { withRouter } from 'react-router';

const useStyles = makeStyles({
  root: {
    justifyContent: 'flex-end',
  },
});

function Login({ loginUserService, history }) {
  const classes = useStyles();
  const [user, setUser] = useState(getNewUser());

  const onLogin = () => {
    loginUserService(user, () => {
      history.push('/therapeuticArea');
    });
  };

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{
        marginTop: 50,
      }}
    >
      <Grid item>
        <Card>
          <CardContent>
            <TextField
              id="username"
              label="Username"
              variant="outlined"
              fullWidth
              value={user.userName}
              onChange={e =>
                setUser({
                  ...user,
                  userName: e.target.value,
                })
              }
              required
              error={!user.userName}
              type="text"
            />
            <TextField
              id="password"
              label="Password"
              variant="outlined"
              fullWidth
              value={user.password}
              onChange={e =>
                setUser({
                  ...user,
                  password: e.target.value,
                })
              }
              style={{
                marginTop: 16,
              }}
              required
              error={!user.password}
              type="password"
            />
          </CardContent>
          <CardActions className={classes.root}>
            <Button
              variant="outlined"
              color="primary"
              onClick={onLogin}
              disabled={!user.userName || !user.password}
            >
              Login
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  loginUserService: (user, cb) => dispatch(loginUser(user, cb)),
});

export default withRouter(connect(null, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/login/Login.js